import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const WelcomeThree = () => { 
    
    return(
        <>
        {/*About Section*/}
        <section className="about-section section-padding-one">
            <div className="default-container">
            <div className="row clearfix">
                {/*o-title Column*/}
                <div className="o-title-column col-lg-6">
                {/*Sec o-title*/}
                <div className="sec-o-title">
                    <div className="o-title-text">Welcome</div>
                    <h2 className="transform-uppercase">25 YEARS <span>EXPERIENCE IN THIS FIELD</span></h2>
                </div>
                <div className="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehen derit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</div>
                <Link to="#" className="o-btn btn-style-ten">More</Link>
                </div>
                {/*Video Column*/}
                <div className="o-video-col col-lg-6">
                <div className="inner-column animate bounce">
                    {/*Video holder*/}
                    <div className="video-holder">
                    <figure className="image">
                        <img src="images/background/play-01.png" alt="play" />
                    </figure>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End About Section*/}
        </>
    )
}

export default WelcomeThree;